import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import BlacklistsGrid from '../components/Grid';
import { BlacklistProvider } from '../store';

import BlacklistFormLayout from './Form';

const BlacklistBulkImportLayout = () => <BlacklistFormLayout bulk />

export default function BlacklistsGridLayout() {
  return <BlacklistProvider>
    <BlacklistsGrid />
    <Router>
      <PrivateRoute exact path="/settings/blacklist/import" component={BlacklistBulkImportLayout} />
      <PrivateRoute path={["/settings/blacklist/add", "/settings/blacklist/:id"]} component={BlacklistFormLayout} />
    </Router>
  </BlacklistProvider>;
}
